/* BB 2026 — shared popup.
   Any element with data-bb-modal-open="<id>" opens the matching .bb-modal.
   Triggers keep a real href so the popup is an enhancement, never a dependency. */
(function () {
  if (window.__bbModalReady) return;
  window.__bbModalReady = true;

  var lastFocus = null;

  // A dialog is only "above everything" if nothing above it has already opened
  // a stacking context. On the PDP the popup is rendered inside the sticky
  // product column, which is `position: sticky; z-index: 5` — so its own
  // z-index of 99998 only ever ranked inside that column, and anything painted
  // later (the card over the gallery) covered it. Moving each popup to the end
  // of <body> takes it out of every such context for good.
  function liftToBody(root) {
    (root || document).querySelectorAll('.bb-modal').forEach(function (modal) {
      if (modal.parentElement === document.body) return;
      // A re-rendered section brings a fresh copy with the same id; the one
      // already on <body> is the stale one.
      if (modal.id) {
        var old = document.body.querySelector(':scope > #' + CSS.escape(modal.id));
        if (old && old !== modal) old.remove();
      }
      document.body.appendChild(modal);
    });
  }
  if (document.readyState !== 'loading') liftToBody();
  document.addEventListener('DOMContentLoaded', function () { liftToBody(); });
  document.addEventListener('shopify:section:load', function (e) { liftToBody(e.target); });

  // A trigger may name one material, in which case the popup shows only that
  // card. Anything else opens the full guide.
  function applyFilter(modal, slug) {
    var cards = modal.querySelectorAll('[data-mat]');
    if (!cards.length) return;
    var note = modal.querySelector('.bb-modal__filternote');
    var legend = modal.querySelector('.bb-modal__legend');
    var matched = 0;
    cards.forEach(function (c) {
      var show = !slug || c.getAttribute('data-mat') === slug;
      c.hidden = !show;
      if (show) matched++;
    });
    // A slug that matches nothing falls back to showing everything.
    if (slug && matched === 0) { cards.forEach(function (c) { c.hidden = false; }); slug = null; }
    if (note) note.hidden = !slug;
    if (legend) legend.hidden = !!slug;
    // The panel narrows to fit one card, and widens again on "see all".
    modal.classList.toggle('is-single', !!slug);
    var body = modal.querySelector('.bb-modal__body');
    if (body) body.scrollTop = 0;
  }

  function open(modal, trigger) {
    if (!modal) return;
    lastFocus = trigger || document.activeElement;
    applyFilter(modal, trigger && trigger.getAttribute('data-bb-material'));
    modal.hidden = false;
    // next frame so the transition runs
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var close = modal.querySelector('[data-bb-modal-close]');
    if (close) close.focus();
  }

  function close(modal) {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var done = function () {
      modal.hidden = true;
      modal.removeEventListener('transitionend', done);
    };
    modal.addEventListener('transitionend', done);
    // belt and braces if the transition never fires
    setTimeout(function () { if (!modal.classList.contains('is-open')) modal.hidden = true; }, 400);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bb-modal-open]');
    if (trigger) {
      var modal = document.getElementById(trigger.getAttribute('data-bb-modal-open'));
      if (modal) { e.preventDefault(); open(modal, trigger); }
      return;
    }
    if (e.target.closest('[data-bb-mat-all]')) {
      applyFilter(e.target.closest('.bb-modal'), null);
      return;
    }
    if (e.target.closest('[data-bb-modal-close]') || e.target.hasAttribute('data-bb-modal-scrim')) {
      close(e.target.closest('.bb-modal'));
    }
  });

  // Shopify's richtext sanitiser strips class and data-* from anchors, so the
  // "See all wallpaper materials" link cannot carry the trigger in the template.
  // Upgrade it here instead: it stays a real link until this runs.
  function upgradeLinks() {
    document.querySelectorAll('a[href*="wallpaper-material-types"]').forEach(function (a) {
      if (a.dataset.bbUpgraded === '1') return;
      // The popup's own footer link points at the same page; leave it alone.
      if (a.closest('.bb-modal')) return;
      if (!document.getElementById('bb-materials')) return;
      a.setAttribute('data-bb-modal-open', 'bb-materials');
      a.classList.add('bb-inline-btn');
      a.textContent = a.textContent.replace(/\s*[→>]\s*$/, '').trim();
      // "Rope Roll" names one material; "See all wallpaper materials" does not.
      var label = a.textContent.trim().toLowerCase();
      var generic = /^(see all|wallpaper material|all wallpaper)/.test(label);
      if (!generic) {
        var slug = label.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        if (document.querySelector('#bb-materials [data-mat="' + slug + '"]')) {
          a.setAttribute('data-bb-material', slug);
        }
      }
      a.dataset.bbUpgraded = '1';
    });
  }
  if (document.readyState !== 'loading') upgradeLinks();
  document.addEventListener('DOMContentLoaded', upgradeLinks);
  document.addEventListener('shopify:section:load', upgradeLinks);
  document.addEventListener('turbo:load', upgradeLinks);
  document.addEventListener('page:loaded', upgradeLinks);
  // The Materials & Care panel renders its content after load in places.
  setTimeout(upgradeLinks, 800);
  setTimeout(upgradeLinks, 2000);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openModal = document.querySelector('.bb-modal.is-open');
    if (openModal) close(openModal);
  });
})();
